import { render } from "./MobilePaymentSvg.vue?vue&type=template&id=4d8c8e46"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__